export default __webpack_public_path__ + "static/media/bellAlert.4150319f.svg";